import { FAQS } from "@/data/site";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
    return (
        <div data-testid="faq-page" className="pt-32 pb-20">
            <div className="container-vv max-w-3xl">
                <div className="label-eyebrow">Common Questions</div>
                <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-cream mt-4 text-balance">
                    Frequently Asked <span className="italic text-gold">Questions</span>
                </h1>
                <p className="mt-6 text-cream-muted leading-relaxed">
                    Everything you need to know about booking, sessions, payments, and Dr. Tannu's approach.
                </p>

                <div className="mt-12">
                    <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
                        {FAQS.map((f, i) => (
                            <AccordionItem
                                key={i}
                                value={`faq-${i}`}
                                className="border border-gold/20 rounded-xl bg-ink-surface/40 px-5"
                                data-testid={`faq-item-${i}`}
                            >
                                <AccordionTrigger className="text-left text-cream font-serif text-lg hover:no-underline py-5">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-cream-muted leading-relaxed pb-5">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </div>
        </div>
    );
}
